import { handleReadTimeOnPageLoad, processReadTimeLink } from './readtime.js';
import { socialShare } from './socialshare.js';
import { formatDate } from './date.js';
import { currentTime } from './time.js';
import { onClick } from './onclick.js';
import { copyToClipboard } from './copyclip.js';
import { popupsIntent } from './popup.js';
import { cmsNest } from './cmsnest.js';
import { backButtons } from './backbutton.js';
import { generateTOC } from './toc.js';
import { transitionDelay } from './transitiondelay.js';
import { showNavScroll } from './shownavscroll.js';
import { initializeCountdowns } from './countdowntimer.js';
import { initializeToastButtons } from './toast.js';
import { countUp } from './countup.js';
import { customTabs, timedTabs } from './tabs.js';
import { handleChildHoverState } from './hoverstate.js';
import { generateTooltip } from './tooltip.js';
import { cmsRandomSort } from './cmsrandomsort.js';
import { initSlider } from './slider.js';
import { removeElements } from './removeelement.js';
import { filterItems } from './filters.js';
import { generateFootnotes } from './footnotes.js';
import { mirrorClick } from './mirrorclick.js';
import { addSmoothScroll } from './scrolloffset.js';
import { accordian } from './accordian.js';
import { urlParams } from './urlparams.js';
import { togglePasswordVisibility } from './hideshowpassword.js';

import { horizontalScroll } from './GSAPHorizontalScroll.js';
import { staggerIn } from './GSAPStagger.js';
import { typewriter } from './GSAPTypewriter.js';
import { maskedText } from './GSAPMaskedText.js';
import { redirectURL } from './redirectURL.js';
import { revealHiddenText } from './GSAPRevealHiddenText.js';
import { openDropdown } from './opendropdown.js';
import { initBreadcrumbs } from './breadcrumbs.js';

export const functions = () => {
    const nestLinks = document.querySelectorAll("[vdx-nest-link]");
    cmsRandomSort();
    if (nestLinks.length > 0) {
        cmsNest();
    }
    // Once cmsNest is done (or if no vdx-nest-link elements), run the other scripts
    document.querySelectorAll("[vdx-readtime-link]").forEach(processReadTimeLink);
    handleReadTimeOnPageLoad();
    socialShare();
    formatDate();
    currentTime();
    onClick();
    copyToClipboard();
    popupsIntent();
    backButtons();
    generateTOC();
    transitionDelay();
    showNavScroll();
    initializeCountdowns();
    initializeToastButtons();
    countUp();
    customTabs();
    timedTabs();
    handleChildHoverState();
    generateTooltip();
    removeElements();
    initSlider();
    removeElements();
    generateFootnotes();
    mirrorClick();
    filterItems();
    addSmoothScroll();
    accordian();
    urlParams();
    togglePasswordVisibility();
    horizontalScroll();
    staggerIn();
    typewriter();
    maskedText();
    revealHiddenText();
    redirectURL();
    openDropdown();
    initBreadcrumbs();
};